module.exports = __webpack_public_path__ + "img/MoradaNova.9218c17a.png";